import { render, staticRenderFns } from "./TecnicosDetalle.vue?vue&type=template&id=a1b36c9c&scoped=true"
import script from "./TecnicosDetalle.vue?vue&type=script&lang=js"
export * from "./TecnicosDetalle.vue?vue&type=script&lang=js"
import style0 from "./TecnicosDetalle.vue?vue&type=style&index=0&id=a1b36c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b36c9c",
  null
  
)

export default component.exports